import { render, staticRenderFns } from "./CarriersMarkups.vue?vue&type=template&id=40612d85&scoped=true"
import script from "./CarriersMarkups.vue?vue&type=script&lang=js"
export * from "./CarriersMarkups.vue?vue&type=script&lang=js"
import style0 from "./CarriersMarkups.vue?vue&type=style&index=0&id=40612d85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40612d85",
  null
  
)

export default component.exports